import { createContext } from 'react';

import type { Lucid } from '../../../types/types';

export const ABTestContextGlobal = createContext({
  dispatchAbTest: () => undefined,
  tests: {
    Dummy: {
      branch: 'T_A',
      branches: {
        T_A: 1,
        T_B: 1,
      },
      branchesToRender: [],
      hasTriggerFired: false,
      shouldShowShield: false,
      testName: 'Dummy',
      trigger: 'load',
      handleOnTrigger: () => undefined,
      handleUpdateBranch: () => undefined,
    },
  },
} as Lucid.Context.ABTest.Global);

export default ABTestContextGlobal;
